import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import ProjectPnLSection from "@/components/ProjectPnLSection";

/* Project P&L tab — pick a project, reuse the per-project section.
   Extracted from Finance.jsx (Feb 2026 split). */
export default function ProjectPnLTab() {
  const [projects, setProjects] = useState([]);
  const [projectId, setProjectId] = useState("");
  useEffect(() => { api.get("/daily-tasks/projects").then(({ data }) => setProjects(data || [])).catch(() => setProjects([])); }, []);
  return (
    <div data-testid="finance-project-pnl-tab">
      <div className="mb-4 max-w-xs">
        <Label className="label-overline">Project</Label>
        <Select value={projectId} onValueChange={setProjectId}>
          <SelectTrigger className="rounded-sm mt-1" data-testid="finance-pnl-project-select"><SelectValue placeholder="Pick a project" /></SelectTrigger>
          <SelectContent>{projects.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      {projectId ? (
        <ProjectPnLSection projectId={projectId} />
      ) : (
        <div className="card-flat p-8 text-center text-sm text-slate-400">Pick a project above to see its P&amp;L.</div>
      )}
    </div>
  );
}
